import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form } from 'antd';
import LabelInput from '../../../../../common/components/LabelInput';
import MyPageAlert from '../../../../../common/components/MyPageAlert';
import { ErrorIcon } from '../../../../../common/icons';
import LoadingOverlay from 'react-loading-overlay';
import { PulseLoader } from 'react-spinners';
import StepBadge from '../StepBadge';

import './RegForm.css';
import RegPrivacyPolicy from '../RegPrivacyPolicy';
import AdditionServiceConditions from '../AdditionServiceConditions/AdditionServiceConditions';
import { emailValidator } from '../../../../../helpers';
import MoveInAppWarning from '../../../../../common/components/MoveInAppWarning';

const BellIcon = () => (
  <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path d="M21 19a2 2 0 0 1-2 2h-1v-6h3zM3 19a2 2 0 0 0 2 2h1v-6H3z" />
  </svg>
);

@inject('translationsStore', 'moveinStore')
@observer
class RegForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alreadySubmitted: false
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ alreadySubmitted: true });

    this.props.form.validateFields((err, values) => {
      if (!err && values.marketingAgreement !== null) {
        this.props.onClickReg(values.email, values.phone, values.marketingAgreement, values.marketingThirdPartiesAgreement);
      }
    });
  };

  handleFreeServiceChoice = () => {
    this.setState({freeServiceSelected: true});
  };

  handleFreeServiceChoiceCancel = () => {
    const { moveinStore } = this.props;

    moveinStore.unsetVehicleAdditionalServiceConsent();
    this.setState({freeServiceSelected: false});
  };

  handleFreeServiceSubmit = () => {
    this.setState({ alreadySubmitted: true });

    this.props.form.validateFields((err, values) => {
      if (!err && values.marketingAgreement !== null) {
        this.props.onClickReg(values.email, values.phone, values.marketingAgreement, values.marketingThirdPartiesAgreement, true);
      }
    });
  };

  getFieldError = field => {
    const { isFieldTouched, getFieldError } = this.props.form;
    return (isFieldTouched(field) || this.state.alreadySubmitted) && getFieldError(field);
  };

  render() {
    const { translationsStore, moveinStore } = this.props,
      { existingData } = moveinStore;
    const { getFieldDecorator, getFieldsValue } = this.props.form;
    const { alreadySubmitted } = this.state;
    let marketingAgreementValue = getFieldsValue(['marketingAgreement'])['marketingAgreement'];
    if (marketingAgreementValue === undefined && !!existingData && existingData.hasOwnProperty('vehicle') && existingData.vehicle.hasOwnProperty('marketing_consent_accepted')) {
      marketingAgreementValue = existingData.vehicle.marketing_consent_accepted;
    }
    const emailError = this.getFieldError('email');
    const phoneError = this.getFieldError('phone');
    const initialThirdParties = undefined;
    const { marketingThirdPartiesAgreement: marketingThirdParties } = getFieldsValue(['marketingThirdPartiesAgreement']);
    const { freeServiceSelected } = this.state;
    const isSubmitWithoutFreeServiceDisabled =
      moveinStore.registered ||
      moveinStore.registering ||
      !(getFieldsValue(['email'])['email'] !== undefined && String(getFieldsValue(['email'])['email']).length > 0) ||
      !(getFieldsValue(['phone'])['phone'] !== undefined && String(getFieldsValue(['phone'])['phone']).length > 0) ||
      marketingAgreementValue === undefined ||
      marketingThirdParties === undefined;
    const isSubmitWithAdditionalServiceDisabled =
      alreadySubmitted ||
      getFieldsValue(['airclub_general'])['airclub_general'] !== true ||
      getFieldsValue(['carefully_read'])['carefully_read'] !== true ||
      getFieldsValue(['air_club_profiling'])['air_club_profiling'] === undefined ||
      getFieldsValue(['air_club_marketing'])['air_club_marketing'] === undefined ||
      getFieldsValue(['air_club_third_parties'])['air_club_third_parties'] === undefined;

    return (
      <div className="RegFormStep mv-hero-bg">
        <div className="RegFormInner">
          <div className="RegFormHead">
            <StepBadge number={2} label={translationsStore.translate('movein.stepRegistration.badge')} />
            <h1 className="mv-h1">{translationsStore.translate('movein.stepRegistration.title')}</h1>
            <p className="mv-lead">{translationsStore.translate('movein.stepRegistration.subtitle')}</p>
          </div>
          <LoadingOverlay
            active={moveinStore.registering}
            spinner={<PulseLoader sizeUnit={'px'} size={20} color={'var(--action-primary-color)'} loading={true} />}
            styles={{
              overlay: base => ({
                ...base,
                background: 'var(--grey-light-color-50)'
              })
            }}
          >
            <div className="mv-card RegFormCard">
              <Form className="RegFormUserDataForm" layout="inline">
                <div className="RegFormAccountSection">
                  <div className="mv-section-title">{translationsStore.translate('movein.stepRegistration.accountSection')}</div>
                  <div className="RegFormAccountFields">
                    <Form.Item validateStatus={emailError ? 'error' : ''} help={emailError || ''}>
                      {getFieldDecorator(
                        'email',
                        Object.assign(
                          {},
                          {
                            preserve: true,
                            rules: [
                              {
                                validator: (undefined, value) => emailValidator(value),
                                message: translationsStore.translate('registration.form.errorInvalidEmail'),
                              },
                              {
                                required: true,
                                message: translationsStore.translate('registration.form.errorMissingEmail'),
                              },
                            ],
                          },
                          !!existingData && existingData.hasOwnProperty('user') && existingData.user.hasOwnProperty('email') && {
                            initialValue: existingData.user.email
                          }
                        )
                      )(<LabelInput label={translationsStore.translate('registration.form.email')} placeholder={translationsStore.translate('registration.form.placeholderEmail')} disabled={!!existingData} />)}
                    </Form.Item>
                    <Form.Item validateStatus={phoneError ? 'error' : ''} help={phoneError || ''}>
                      {getFieldDecorator(
                        'phone',
                        Object.assign(
                          {},
                          {
                            preserve: true,
                            rules: [
                              {
                                validator: (rule, value, callback) =>
                                    callback(!value.match(/^\+39[1-9]\d{7,11}$/) ? translationsStore.translate('registration.form.errorInvalidPhoneNumber') : undefined),
                              },
                            ],
                          },
                          !!existingData && existingData.hasOwnProperty('user') && existingData.user.hasOwnProperty('mobile') && {
                            initialValue: existingData.user.mobile
                          }
                        )
                      )(<LabelInput label={translationsStore.translate('registration.form.phoneNumber')} placeholder={translationsStore.translate('registration.form.placeholderPhoneNumber')} />)}
                    </Form.Item>
                  </div>
                </div>
                <Form.Item style={{ width: '100%', flex: '0 1 auto', margin: 0 }}>
                  <div className="alert">
                    {moveinStore.lastError !== null &&
                      moveinStore.lastError.key === 'registerUserRemoteError' &&
                      (() => {
                        const lastErrorString =
                          moveinStore.lastError.meta !== null
                            ? translationsStore.translate(`movein.stepRegistration.errorRemoteServer.${moveinStore.lastError.meta}`)
                            : translationsStore.translate(`movein.stepRegistration.errorRemoteServer.default`);
                        return (
                          <MyPageAlert
                            style={{ margin: '0 30px 24px' }}
                            message={translationsStore.translate('registration.errors.submit')}
                            description={lastErrorString}
                            type="error"
                            showIcon
                            icon={<ErrorIcon width={20} height={20} />}
                          />
                        );
                      })()}
                  </div>

                  <div className="RegFormConsentsSection">
                    <div className="RegFormConsentsTitle">
                      {translationsStore.translate('movein.stepRegistration.consentsSection')}
                    </div>
                    <RegPrivacyPolicy
                      form={this.props.form}
                      submitted={this.state.alreadySubmitted}
                      marketingValue={getFieldsValue(['marketingAgreement'])['marketingAgreement']}
                      initialValue={
                        !!existingData && existingData.hasOwnProperty('vehicle') && existingData.vehicle.hasOwnProperty('marketing_consent_accepted')
                          ? existingData.vehicle.marketing_consent_accepted
                          : undefined
                      }
                      initialThirdParties={initialThirdParties}
                      marketingThirdParties={marketingThirdParties}
                      disabled={!!existingData && existingData.hasOwnProperty('vehicle') && existingData.vehicle.hasOwnProperty('marketing_consent_accepted')}
                    />
                  </div>

                  <div className="RegFormFooterBand">
                    <div className="RegFormPromoBox">
                      <span className="RegFormPromoIcon">
                        <BellIcon />
                      </span>
                      <div className="RegFormPromoBody">
                        <div className="RegFormPromoTitleRow">
                          <span className="RegFormPromoTitle">{translationsStore.translate('movein.stepRegistration.freeService.promoTitle')}</span>
                          <span className="RegFormPromoChip RegFormPromoChipSolid">{translationsStore.translate('movein.stepRegistration.freeService.freeChip')}</span>
                          <span className="RegFormPromoChip">{translationsStore.translate('movein.stepRegistration.freeService.moveinExclusive')}</span>
                        </div>
                        <div className="RegFormPromoText">
                          <span>{translationsStore.translate('movein.stepRegistration.freeService.reminderServiceDescription')}</span>
                          <span className="RegFormPromoTextBold">{translationsStore.translate('movein.stepRegistration.freeService.reminderServiceDescriptionFeatures')}</span>{' '}
                          <span>{translationsStore.translate('movein.stepRegistration.freeService.reminderServiceDescription2')}</span>
                          <span className="RegFormPromoTextBold">{translationsStore.translate('movein.stepRegistration.freeService.reminderServiceDescriptionFeatures2')}</span>
                        </div>
                      </div>
                    </div>
                    {!freeServiceSelected && (
                      <div className="RegFormButtons">
                        <button type="button" className="mv-btn" onClick={this.handleFreeServiceChoice} disabled={isSubmitWithoutFreeServiceDisabled}>
                          {translationsStore.translate('registration.form.submitWithFreeReminderService')}
                        </button>
                        <button type="button" className="mv-btn mv-btn--ghost" onClick={this.handleSubmit} disabled={isSubmitWithoutFreeServiceDisabled}>
                          {translationsStore.translate('registration.form.submit')}
                        </button>
                      </div>
                    )}
                    {freeServiceSelected && (
                      <AdditionServiceConditions
                        form={this.props.form}
                        onSubmit={this.handleFreeServiceSubmit}
                        onCancelFreeService={this.handleFreeServiceChoiceCancel}
                        isSubmitWithAdditionalServiceDisabled={isSubmitWithAdditionalServiceDisabled}
                        alreadySubmitted={alreadySubmitted}
                      />
                    )}
                  </div>
                </Form.Item>
              </Form>
            </div>
          </LoadingOverlay>
          <MoveInAppWarning className="RegFormAppWarn" />
        </div>
      </div>
    );
  }
}

export default RegForm;
